<template>
  <div id="app">
    <v-app>
      <v-main class="pa-0 rhapsody-bg">
        <v-row no-gutters justify="center">
          <v-theme-provider light>
            <v-container fill-height>
              <v-row justify="center" class="pa-2 rhapsody-login-full-screen">
                <v-col cols="12" xs="6" sm="6" md="6" lg="6" class="main-col">
                  <svg
                    class="rhapsody-logo"
                    focusable="false"
                    viewBox="0 0 145 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M119.9 36.5a1.4 1.4 0 01-1.5 1.5 1.4 1.4 0 01-1.4-1.5 1.4 1.4 0 011.4-1.4 1.4 1.4 0 011.5 1.4zM10 17.7v.2c0 .3-.2.5-.4.6l-.7.1H7.3c-1.5 0-2.7.3-3.6 1-1 .8-1.4 1.8-1.4 3v8.6c0 .3-.1.6-.3.8l-.9.2c-.4 0-.6 0-.8-.2a1 1 0 01-.3-.8V17.7c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.4 0 .7.1.9.3.2.2.3.5.3.8V19A5.8 5.9 0 014.5 17a6.5 6.5 0 014.8-.3c.5.2.7.5.7.9zm17.8 2.2a8 8 0 011 3.9v7.4c0 .3-.2.5-.4.7a1 1 0 01-.8.3 1 1 0 01-.8-.3 1 1 0 01-.3-.7v-7.4c0-1.7-.4-3-1.4-3.9-.9-.9-2.1-1.3-3.6-1.3-1 0-1.8.2-2.5.5-.8.4-1.4.9-1.8 1.5a3.6 3.7 0 00-.7 2.1v8.5c0 .3 0 .5-.3.7a1 1 0 01-.7.3c-.4 0-.6 0-.8-.3a1 1 0 01-.3-.7v-20c0-.4 0-.6.3-.9.2-.2.4-.3.8-.3.3 0 .5.1.7.3.2.3.3.5.3.8v7.7a6.6 6.6 0 012.3-1.7 7.6 7.6 0 016.5.3c1 .5 1.9 1.4 2.5 2.5zM46 27.4a6 6 0 00.8-3 6 6 0 00-.8-3 5.6 5.6 0 00-2-2.2c-1-.5-1.9-.7-3-.7-1 0-2 .2-3 .7a5.6 5.6 0 00-2 2.2 6 6 0 00-.7 3 6 6 0 00.7 3 5.5 5.5 0 002 2c1 .6 2 .9 3 .9s2-.3 3-.8a5.5 5.5 0 002-2.1zm1.9-7a8 8 0 011 4V31a1 1 0 01-.3.8 1 1 0 01-.8.3c-.3 0-.6-.1-.8-.3a1 1 0 01-.3-.8v-1.7a7 7 0 01-2.5 2.2c-1 .5-2.2.7-3.4.7a7.5 7.5 0 01-6.7-3.8 8 8 0 01-1-4 8 8 0 011-4 7.5 7.6 0 012.9-2.9 8 8 0 014-1 8 8 0 014 1 7.5 7.6 0 012.9 2.9zm37-1.5l.2.6c0 .4-.1.6-.4.8l-.6.1a1.3 1.3 0 01-1-.4c-.9-1-2.1-1.6-3.7-1.6-1 0-1.9.2-2.5.7-.6.4-.9 1-.9 1.6 0 .6.3 1.2.9 1.6a8 8 0 003 1c2 .3 3.5.9 4.3 1.6.9.8 1.3 1.7 1.3 2.9 0 .8-.2 1.6-.7 2.3a5 5 0 01-2.2 1.6 9.5 9.5 0 01-6.4 0c-1-.5-2-1-2.6-1.7a1 1 0 01-.3-.7c0-.3.2-.6.5-.8.2-.2.4-.3.7-.3.3 0 .6.2.8.4.4.5 1 1 1.8 1.2.7.3 1.5.5 2.4.5 1.3 0 2.3-.3 3-.7.6-.5 1-1 1-1.8 0-.7-.4-1.2-1-1.7-.7-.5-1.7-.8-3.1-1a8.6 8.6 0 01-4.1-1.6c-1-.7-1.4-1.6-1.4-2.7 0-1.4.5-2.4 1.6-3.2 1-.7 2.4-1.1 4-1.1 1.2 0 2.3.2 3.2.6.9.4 1.6 1 2.2 1.8zm8.5 2.4c-.5 1-.7 2-.7 3a6 6 0 00.7 3 5.5 5.5 0 002.1 2.2c.9.5 1.9.8 3 .8 1 0 2-.3 2.9-.8a5.4 5.4 0 002-2.1 6.2 6.2 0 000-6 5.4 5.4 0 00-2-2.2c-.9-.5-1.9-.7-3-.7-1 0-2 .2-2.9.7a5.5 5.5 0 00-2 2.1zm11.9-1a8 8 0 011 4 8 8 0 01-1 4.1 7.3 7.4 0 01-2.8 2.8 8 8 0 01-4 1 8 8 0 01-4.1-1 7.3 7.4 0 01-2.8-2.8 8 8 0 01-1-4 8 8 0 011-4 7.3 7.3 0 012.8-2.9c1.2-.7 2.5-1 4-1s2.9.3 4 1c1.3.7 2.2 1.6 2.9 2.8zm21.1 3.9c0 1.5-.3 2.9-1 4a7.6 7.6 0 01-6.9 4 7.8 7.8 0 01-6.8-4c-.7-1.1-1-2.5-1-4s.3-2.9 1-4a7.6 7.6 0 0110-3.2 7 7 0 012.5 2.2v-18c0-.4.1-.7.3-.9.2-.2.5-.3.8-.3.4 0 .6.1.8.3.2.2.3.5.3.8v23.1zm-2.9 3a6.3 6.3 0 00.7-3.7.3.3 0 010-.2 5.8 5.8 0 00-1.8-3.6c-1-1-2.4-1.5-3.9-1.5-1 0-2 .3-2.9.8a5.5 5.5 0 00-2 2.1c-.6 1-.8 2-.8 3.1s.2 2.2.7 3a5.6 5.7 0 002.1 2.2c.9.6 1.9.8 3 .8s2-.2 2.9-.8a5.7 5.7 0 002-2.1zm21.3-10.4a1 1 0 00-.8-.3 1 1 0 00-.7.3c-.2.2-.3.5-.3.8v8.7a4 4 0 01-.6 2.1c-.5.7-1 1.2-1.8 1.6-.7.3-1.5.5-2.4.5-1.5 0-2.6-.4-3.5-1.3-1-1-1.4-2.3-1.4-4v-7.6c0-.3-.1-.6-.3-.8a1 1 0 00-.8-.3 1 1 0 00-.7.3c-.2.2-.3.5-.3.8v7.6c0 1.6.3 2.9.9 4 .5 1.1 1.4 2 2.4 2.6a7 7 0 006.3.2 6.4 6.5 0 002.2-1.7v2.2c0 1.2-.2 2.3-.7 3.2-.5 1-1.1 1.7-2 2.3a5 5 0 01-2.7.8c-1.1 0-2-.2-2.9-.6a5.6 5.6 0 01-2-1.8 1 1 0 00-.5-.3 1 1 0 00-.5-.1 1 1 0 00-.7 1.6 8 8 0 002.8 2.4 8.1 8.1 0 007.6-.3c1.2-.7 2-1.7 2.7-3 .7-1.2 1-2.6 1-4.2v-15c0-.2-.1-.5-.3-.7m-90.9 7c0-1.5.4-2.9 1-4a7.6 7.6 0 017-4 7.8 7.8 0 016.8 4c.7 1.1 1 2.5 1 4s-.3 2.9-1 4a7.6 7.6 0 01-10 3.2 7 7 0 01-2.5-2.2v18c0 .4-.2.7-.4.9a1 1 0 01-.8.3 1 1 0 01-.7-.3c-.2-.2-.3-.5-.3-.8v-16a.9.9 0 010-.3v-6.8zm3-3a6.3 6.3 0 00-.8 3.7.3.3 0 010 .2c.2 1.5.9 2.7 2 3.6 1 1 2.2 1.5 3.7 1.5 1.1 0 2-.3 3-.8a5.5 5.5 0 002-2.1c.5-1 .8-2 .8-3.1s-.3-2.2-.8-3a5.6 5.7 0 00-2-2.2c-1-.6-1.9-.8-3-.8s-2 .2-2.9.8a5.7 5.7 0 00-2 2.1z"
                      fill="#480A00"
                    ></path>
                  </svg>

                  <div class="login-container">
                    <v-img
                      class="cat"
                      contain
                      src="https://cdn.rhapsody.vet/portal/2020/08/04/0.0.8227/build/static/media/CreepingCat.7ab33fe9.png"
                    ></v-img>
                    <v-card class="rhapsody-login">
                      <v-card-title class="justify-center">
                        <h3 class="primary--text">Price matcher</h3>
                      </v-card-title>
                      <v-divider></v-divider>
                      <!-- <div class="py-4" id="googleSignInButton"></div> -->
                      <div class="py-4">
                        <!-- The Google Sign-In button container -->
                        <div ref="googleSignInButton"></div>
                      </div>
                    </v-card>
                    <v-img
                      class="dog"
                      contain
                      src="https://cdn.rhapsody.vet/portal/2020/08/04/0.0.8227/build/static/media/DoctorDoggie.6f4b0956.png"
                    ></v-img>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-row>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import Config from '../config';
import { Axios, AuthService } from '../services';

export default {
  data: () => ({
    Config: Config,
    valid: true,
    name: '',
    nameRules: [
      (v) => !!v || 'Name is required',
      (v) => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    select: null,
    items: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
    checkbox: false
  }),
  mounted() {
    if (!window.google) {
      // Expose the callback function globally so that Google's script can call it.
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = this.initializeLogin;
      document.head.appendChild(script);
    } else {
      this.initializeLogin();
    }
  },
  methods: {
    initializeLogin() {
      window.google.accounts.id.initialize({
        client_id:
          '251880311786-0lr2b7macjpar0s2fm611plkr6vssaai.apps.googleusercontent.com',
        callback: this.doLogin
      });
      window.google.accounts.id.renderButton(this.$refs.googleSignInButton, {
        theme: 'outline',
        size: 'large'
      });
    },
    async doLogin(response) {
      try {
        Axios.Auth.setToken(response.credential);

        const { user, access_token } = await Axios.Auth.post(
          '/v1/google/callback',
          {
            code: response.credential,
            redirect_uri: 'postmessage'
          }
        );

        AuthService.setLogin({
          access_token,
          user
        });
        Axios.Api.setToken(access_token);

        this.$router.push({ path: 'home/tasks' });
      } catch (error) {
        console.error('err', error);
      }
    }
  }
};
</script>

<style lang="scss">
.rhapsody-bg {
  min-height: 100vh;
  background-size: 100%, auto;
  background-image: url(https://cdn.rhapsody.vet/portal/2020/08/04/0.0.8227/build/static/media/LoginBackground.27e7c54c.svg);
  background-repeat: no-repeat;
  background-position: bottom center;
  .rhapsody-login-full-screen {
    .main-col {
      @media (max-width: 800px) {
        max-width: 315px;
      }
      height: 100vh;
      .rhapsody-logo {
        width: 239px;
        cursor: pointer;
        height: 79px;
        margin: auto;
        display: block;
        margin-top: 56px;
        margin-bottom: 120px;
      }
      .login-container {
        position: relative;
        .cat {
          position: absolute;
          height: 111px;
          width: 179px;
          top: -57px;
          right: -47px;
          pointer-events: none;
        }
        .dog {
          position: absolute;
          height: 157px;
          width: 179px;
          left: -124px;
          pointer-events: none;
          bottom: -83px;
        }

        .rhapsody-login {
          margin: auto;
          margin-top: 10vh;
          box-shadow:
            -1px -1px 8px 0 rgba(99, 95, 95, 0.1),
            1px 1px 8px 0 rgba(0, 0, 0, 0.1) !important;
          padding-left: 50px;
          border-radius: 4px;
          margin-bottom: 8px;
          padding-right: 50px;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>
